import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@mono/ui-components';
import { useState } from 'react';
/**
 * ConfirmDialog replaces `window.confirm()`. Uses AlertDialog for an
 * accessible "are you sure?" pattern.
 */ export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = 'Confirm', destructive = false, onConfirm }) {
    const [pending, setPending] = useState(false);
    async function handle() {
        setPending(true);
        try {
            await onConfirm();
            onOpenChange(false);
        } finally{
            setPending(false);
        }
    }
    return /*#__PURE__*/ _jsx(AlertDialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(AlertDialogContent, {
            children: [
                /*#__PURE__*/ _jsxs(AlertDialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(AlertDialogTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(AlertDialogDescription, {
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(AlertDialogFooter, {
                    children: [
                        /*#__PURE__*/ _jsx(AlertDialogCancel, {
                            disabled: pending,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ _jsx(AlertDialogAction, {
                            onClick: handle,
                            disabled: pending,
                            className: destructive ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90' : '',
                            children: pending ? 'Working…' : confirmLabel
                        })
                    ]
                })
            ]
        })
    });
}
